import {createContext, type ReactNode, useContext, useState} from "react";
import {useCitiesStorage} from "@/hooks/useCitiesStorage.ts";

interface CityContextType {
    currentCity: string
    changeCurrentCity: (s: string) => void
}

export const KEY = import.meta.env.VITE_STORAGE_KEY as string

const CurrentCityContext = createContext<CityContextType | null>(null)

export function useCurrentCity() {
    const currentCityContext = useContext(CurrentCityContext)
    if (!currentCityContext) throw new Error("Current city context is not defined")
    return currentCityContext
}

export function CurrentCityProvider({ children }: { children: ReactNode }) {
    const { get } = useCitiesStorage(KEY)
    const registeredCities = get()
    const [currentCity, setCurrentCity] = useState(registeredCities ? registeredCities[registeredCities.length - 1].name : "")

    const changeCurrentCity = (n: string) => setCurrentCity(n)

    return <CurrentCityContext.Provider value={{ currentCity, changeCurrentCity }}>
        {children}
    </CurrentCityContext.Provider>
}

